import { PERMISSIONS } from '../../constants'
import list from './ListRecurringSend'
import edit from './EditRecurringSend'
import create from './CreateRecurringSend'
import show from './ShowRecurringSend'

export default {
  list,
  edit,
  create,
  show,
  name: 'chains/chainId/recurring-send',
  permissions: [PERMISSIONS.UNIFIED_SEND]
}
